import type { InboundDoc } from "./inbound-filter";

const COLUMNS: (keyof InboundDoc)[] = [
  "doc_no",
  "doc_type",
  "load_date",
  "load_time",
  "sku",
  "quantity",
  "tran_type",
  "remark",
  "ref_no",
];

function escapeCsv(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function inboundToCsv(items: InboundDoc[]): string {
  const header = COLUMNS.join(",");
  const rows = items.map((it) => COLUMNS.map((c) => escapeCsv(it[c])).join(","));
  return [header, ...rows].join("\n");
}

/** Triggers a browser download of the CSV text. */
export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
